import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CircleIcon from '@mui/icons-material/Circle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import { 
  Button,
  Checkbox, 
  FormControlLabel, 
  IconButton, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Tooltip, 
  Typography} from '@mui/material'
import { collection, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase/firebase';
import { SeverityPill } from './SeverityPill';


const ListaDiagramas = (props) => {

    const {
      diagramas, 
      editarDiagrama, 
      eliminarDiagrama, 
      colection,
      setColecciones,
      colecciones,
      diagramasColeccion,
      idColeccion,
      coleccion,
      agrega,
      arreglo,
      obtenerColecciones,
      nombreColeccion,
      subcol
    } = props;
    
    const [arregloActual, setArregloActual] = useState(arreglo)
    const [coleccionesTotales, setColeccionesTotales] = useState([]);
    const user = auth.currentUser;


    const obtenerColeccionesTotales = async() =>{

      let arrayAux = [];

      try {

          const querySnapshot = await getDocs(collection(db, 'colecciones'));
          querySnapshot.docs.forEach( (doc) => {
          if(doc.data().usuario === user.uid){
              arrayAux.push({id: doc.id, ...doc.data()});
          }
          }); 
          setColeccionesTotales(arrayAux);
          
      } catch (error) {
          
      }
    }
    
    useEffect(() => {
    
      obtenerColeccionesTotales();
      
    }, [])

    //Funcion para agregar diagramas en una
    //coleccion que se esta creando
    const handleCheckBox = (idDocumento, titulo) =>{
      let actualizar = true;
      /* console.log(idDocumento, titulo);
      console.log({nombreColeccion})
      console.log(diagramas) */

      let nuevo = {
        idDocumento,
        titulo
      }

      diagramasColeccion.map((diagrama, index)=>{
        if(diagrama.idDocumento === nuevo.idDocumento){
          diagramasColeccion.splice(index, 1)
          actualizar = false;
        }
      })

      if(actualizar){
        diagramasColeccion.push(nuevo);
      }
      obtenerColeccionesTotales();
    }

    //Funcion para agregar diagramas en una
    //coleccion que ya está creada
    const handleAdd = (idDocumento, titulo) =>{

      let actualizar = true;
      let arrayAux = arregloActual;
      /* 
      console.log(idDocumento, titulo);
      console.log(coleccion.nombre)
      console.log(diagramas)
       */
      let nuevo = {
        idDocumento,
        titulo
      }
      arregloActual.map((diagram, index)=>{
        if(diagram.idDocumento===nuevo.idDocumento){
          // console.log('quitando')
          arrayAux.splice(index, 1);
          actualizar=false;
        }
      })
      if(actualizar){
        arrayAux.push(nuevo);
      }



      /* console.log(arrayAux); */
      setArregloActual(arrayAux);
      obtenerColecciones();
      
    }
    
    const ColeccionComponet = (props) =>{
      return <>
          <SeverityPill
            color={props.color}
            texto={props.nombre}
          />
      </>
        
    }
    
    return (
        <TableContainer component={Paper} >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography
                    variant='h6'
                    sx={{ fontWeight: 'bold' }}
                  >
                    Titulo
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                      variant='h6'
                      sx={{ fontWeight: 'bold' }}
                    >
                      ID
                    </Typography>
                </TableCell>
                {
                  subcol ?
                  (null)
                  :
                  (<TableCell>
                    <Typography
                      variant='h6'
                      sx={{ fontWeight: 'bold' }}
                    >
                      Colección
                    </Typography>
                  </TableCell>)
                }
                
                <TableCell align="right">
                  <Typography
                      variant='h6'
                      sx={{ fontWeight: 'bold' }}
                    >
                      Acciones
                    </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                diagramas.map((row, i)=>(
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">
                      {row.titulo}
                    </TableCell>

                    <TableCell>
                      {row.idDocumento}
                    </TableCell>

                    {
                      subcol ?
                      (null)
                      :
                      (
                        <TableCell>
                          {
                            coleccionesTotales.map((cole, i)=>{
                              if(row.coleccion != undefined){
                                if(row.coleccion.includes(cole.nombre)){
                                  return <ColeccionComponet key={i} color={cole.color} nombre={cole.nombre}/>
                                }
                              }
                            })
                          }
                        </TableCell>
                      )
                    }

                    <TableCell align="right">

                      {colection ? 
                        (
                          <>
                            {
                              agrega ? 
                              ( 
                                <>
                                  { 
                                    (arregloActual.some(diagrama =>{
                                      if(diagrama.idDocumento === row.idDocumento){
                                        return true;
                                      }
                                      return false;
                                    })) ?

                                    (
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            onChange={()=>{handleAdd(row.idDocumento, row.titulo)}}
                                            checked={true}
                                          />
                                        }
                                      />
                                    )
                                    :
                                    (
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            onChange={()=>{handleAdd(row.idDocumento, row.titulo)}}
                                            checked={false}
                                          />
                                        }
                                      />
                                    )

                                  }
                                </>
                              )
                              :
                              (
                                /* diagramasColeccion */
                                <>
                                  {
                                    (diagramasColeccion.some(diagrama =>{
                                      if(diagrama.idDocumento === row.idDocumento){
                                        return true;
                                      }
                                      return false;
                                    })) ?
                                    (
                                      <FormControlLabel
                                        control={
                                        <Checkbox
                                          onChange={()=>{handleCheckBox(row.idDocumento, row.titulo, diagramas)}}
                                          checked={true}
                                        />
                                      }
                                      /> 
                                    )
                                    :
                                    (
                                      <FormControlLabel
                                        control={
                                        <Checkbox
                                          onChange={()=>{handleCheckBox(row.idDocumento, row.titulo, diagramas)}}
                                          checked={false}
                                          />
                                        }
                                      /> 
                                    )
                                  }
                                </>
                              )
                            }
                          </>
                        )
                        :
                        (
                          <>
                            <Tooltip title='Editar diagrama'>
                              <IconButton onClick={()=>{editarDiagrama(row.idDocumento)}}>
                                <EditIcon
                                  color='primary'
                                  fontSize='medium'
                                />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title='Quitar diagrama'>
                              <IconButton onClick={()=>{eliminarDiagrama(row.idDocumento, idColeccion, diagramas)}}>
                                <HighlightOffIcon
                                  color={'error'}
                                  fontSize='medium'
                                />
                              </IconButton>
                            </Tooltip>
                            
                          </>
                        )
                      }
                      

                    </TableCell>

                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
    )
}

export default ListaDiagramas